import css from 'src/helpers/css';

export const giftCardIconCss = css({
	display: 'block',
	width: '80px',
	height: '80px',
	alignSelf: 'center',
	'& > path': {
		strokeWidth: '1'
	}
});
